import accounts from './accounts';
import actionCodes from './action-codes';
import activityLogs from './activity-logs';
import appointments from './appointments';
import auth from './auth';
import chat from './chat';
import datePickers from './date-pickers';
import fixtures from './fixtures';
import formTemplates from './form-templates';
import globalLoader from './global-loader';
import globalSnackbar from './global-snackbar';
import hris from './hris';
import insurance from './insurance';
import medicines from './medicines';
import notifications from './notifications';
import organizations from './organizations';
import patients from './patients';
import prm from './prm';

const log = require('debug')('@mycure/vue-plugins');

/**
 * @typedef {Object} PluginOpts
 * @property {import('vuex').Store} store vuex store
 * @property {boolean} [all=true]
 * @property {boolean|Object.<string,boolean|Object.<string,any>>} [modules=true]
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {PluginOpts} [opts]
   */
  install (Vue, opts) {
    const { all, modules, ...restopts } = opts = Object.assign({ all: true, modules: true }, opts);
    log('installing with opts', opts);

    // inject modules
    [
      accounts,
      actionCodes,
      activityLogs,
      appointments,
      auth,
      chat,
      datePickers,
      fixtures,
      formTemplates,
      globalLoader,
      globalSnackbar,
      hris,
      insurance,
      medicines,
      notifications,
      organizations,
      patients,
      prm
    ].forEach(plugin => {
      if (!modules[plugin.namespace] && modules !== true && all !== true) return;
      Vue.use(plugin, { ...restopts, ...modules[plugin.namespace] });
    });
  }
};
